/**
 * Dedupe de requisições: quando o mesmo recurso é pedido por vários componentes
 * dentro de uma janela curta (ex: BrandThemeProvider + DashboardLayout + página
 * buscando o MESMO tema no mesmo carregamento, ou o banner + o bottom-nav
 * buscando as mesmas cobranças), todos compartilham UMA única requisição de rede
 * em vez de N idênticas.
 *
 * Mantém a Promise em cache por `ttlMs` (default 4s, cobre o burst de montagem
 * sem suprimir o refresh periódico de polling/foco, que ocorrem em intervalos
 * bem maiores). Em erro, evicta na hora pra não cachear falha.
 *
 * Use só pra GETs idempotentes por usuário logado (a sessão já é implícita).
 */
const cache = new Map<string, { promise: Promise<unknown>; ts: number }>()

export function dedupeRequest<T>(key: string, fn: () => Promise<T>, ttlMs = 4000): Promise<T> {
  const agora = Date.now()
  const hit = cache.get(key)
  if (hit && agora - hit.ts < ttlMs) {
    return hit.promise as Promise<T>
  }
  const promise = fn()
  cache.set(key, { promise, ts: agora })
  promise.catch(() => {
    const atual = cache.get(key)
    if (atual && atual.promise === promise) cache.delete(key)
  })
  return promise
}
